import React from 'react';
import styles from './PastPerformanceAside.module.scss';

interface PastPerformanceAsideProps {
  legendData: string[];
  tooltips?: { note: string }[];
}

const PastPerformanceAside: React.FC<PastPerformanceAsideProps> = ({
  legendData,
  tooltips = [],
}) => {
  return (
    <div className={styles['chart-aside']}>
      {/* Chart Legend Section */}
      <div className={styles['chart-legend']}>
        {legendData.map((item, idx) => (
          <div
            key={item}
            className={`${styles['chart-legend__item']} body-small ${idx !== 0 ? 'mt-4' : ''}`}
          >
            <div className={styles['chart-legend__item__identifier']}></div>
            <div className={`${styles['chart-legend__item__name']} ms-2`}>{item}</div>
          </div>
        ))}
      </div>

      {/* Chart Tooltips Section */}
      {tooltips.length > 0 && (
        <div className={`${styles['chart-tooltips']} mt-4`}>
          <ol>
            {tooltips.map((tooltip, idx) => (
              <li key={idx} className={`caption ${idx !== 0 ? 'mt-3' : ''}`}>
                {tooltip.note}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
};

export default PastPerformanceAside;
